// [label, height, width]
import { enumUnitVal } from "@coreapp/constants";
import { GetStdFooterHeight } from "@coreapp/utils/GetStdFooterHeight";
import { GetStdHeaderHeight } from "@coreapp/utils/GetStdHeaderHeight";

export const chartPageSizes = {
  letterps: [816, 1056],
  legalps: [816, 1344],
  tabloidps: [1056, 1632],
  a0ps: [3179, 4494],
  a1ps: [2245, 3179],
  a2ps: [1587, 2245],
  a3ps: [1123, 1587],
  a4ps: [794, 1123],
  ppt1ps: [720, 960],
  ppt2ps: [540, 960],
  customps: [1, 1]
};

export const marginOptions = {
  extrawidem: [72, 72, 72, 72],
  widem: [48, 48, 48, 48],
  standardm: [24, 24, 24, 24],
  narrowm: [0.96, 0.96, 0.96, 0.96],
  customm: [1, 1, 1, 1]
};

export const headerOptions = ["standardh", "noheader", "customh"];

export const footerOptions = ["standardf", "nofooter", "customf"];

export const orientationRadioProps = [
  {
    localLabel: "landscape",
    id: "orientation-landscape"
  },
  {
    localLabel: "portrait",
    id: "orientation-portrait"
  }
];

export const fitScreenRadioProps = [
  {
    localLabel: "Specify page size",
    id: "page-size-specify",
    value: false
  },
  {
    localLabel: "Fit to Screen",
    id: "page-size-fit-screen",
    value: true
  }
];

export const GetOptionKey = (sizes, sizeArray) => {
  return Object.keys(sizes).find(key => sizes[key].toString() === sizeArray.toString());
};

export const GetPageSizeOption = sizeArray => {
  let sizeOption = GetOptionKey(chartPageSizes, sizeArray);
  return sizeOption ? sizeOption : "customps";
};

export const GetMarginSizeOption = sizeArray => {
  let sizeOption = GetOptionKey(marginOptions, sizeArray);
  return sizeOption ? sizeOption : "customm";
};

export const GetHeaderIndex = function (value) {
  const stdHeader = GetStdHeaderHeight(enumUnitVal.pixels); //this.fUnits
  if (stdHeader == value) return 0;
  else if (value <= 1) return 1;
  return 2;
};

export const GetFooterIndex = function (value) {
  const stdFooter = GetStdFooterHeight(enumUnitVal.pixels); //this.fUnits
  if (stdFooter == value) return 0;
  else if (value <= 1) return 1;
  return 2;
};
